var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect8, _rect9, _rect10, _circle7, _circle8, _circle9, _circle10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBudgetSidebarIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.28564,
    width: 17.4286,
    height: 22.2857,
    rx: 1.67033,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.28564,
    y: 2.28571,
    width: 8.57143,
    height: 1.42857,
    rx: 0.714286,
    fill: "#433F3F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.28564,
    y: 11.7143,
    width: 9.42857,
    height: 1.42857,
    rx: 0.714286,
    fill: "#433F3F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.28564,
    y: 5.42856,
    width: 5.71429,
    height: 1.42857,
    rx: 0.714286,
    fill: "#433F3F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8.28564,
    y: 14.8571,
    width: 4.85714,
    height: 1.42857,
    rx: 0.714286,
    fill: "#433F3F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.28564,
    y: 8.57141,
    width: 8.57143,
    height: 1.42857,
    rx: 0.714286,
    fill: "#433F3F"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8.28564,
    y: 18,
    width: 8.57143,
    height: 1.42857,
    rx: 0.714286,
    fill: "#433F3F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.2857,
    cy: 3.14286,
    r: 1.14286,
    fill: "#433F3F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.2857,
    cy: 9.42859,
    r: 1.14286,
    fill: "#433F3F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.2857,
    cy: 6.28571,
    r: 1.14286,
    fill: "#433F3F"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.2857,
    cy: 12.5714,
    r: 1.14286,
    fill: "#433F3F"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.2857,
    cy: 15.7143,
    r: 1.14286,
    fill: "#433F3F"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.2857,
    cy: 18.8572,
    r: 1.14286,
    fill: "#433F3F"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1.16484,
    y: 10.3077,
    width: 12.2418,
    height: 14.5275,
    rx: 2.50549,
    fill: "white",
    stroke: "#433F3F",
    strokeWidth: 1.67033,
    strokeLinejoin: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 3.71436,
    y: 12.8571,
    width: 6.85714,
    height: 2.57143,
    fill: "#433F3F"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 9.14282,
    y: 18,
    width: 1.71429,
    height: 4.28571,
    rx: 0.857143,
    fill: "#433F3F"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5715,
    cy: 18.8571,
    r: 0.857143,
    fill: "#433F3F"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5715,
    cy: 21.4286,
    r: 0.857143,
    fill: "#433F3F"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.14279,
    cy: 18.8571,
    r: 0.857143,
    fill: "#433F3F"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.14279,
    cy: 21.4286,
    r: 0.857143,
    fill: "#433F3F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudgetSidebarIconWhite);
export default __webpack_public_path__ + "static/media/budget_sidebar_icon_white.707501909d5ef93b37d8c0988260620c.svg";
export { ForwardRef as ReactComponent };